import React, {
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import useEmblaCarousel from "embla-carousel-react";
import {
  usePrevNextButtons,
} from "./EmblaCarouselArrowButtons";
import AutoScroll from "embla-carousel-auto-scroll";
import { Message_data } from "../context/context";

export const JukeboxList2 = ({
  jukebox,
  setRequestedTrack,
  pickTrack,
  showChatlist,
  nameThatTuneMode = false,
}) => {
  const csp = useRef(null);
  const [jukeboxList, setJukeboxList] = useState([]);
  const [jukeboxList2, setJukeboxList2] = useState([]);

  const { message, setMessage } = useContext(Message_data);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [widerJbCarousel, setWiderJbCaroursel] = useState(showChatlist);

  useEffect(() => {
    setWiderJbCaroursel(showChatlist);
  }, [showChatlist]);

  // Debug: Log when nameThatTuneMode changes
  useEffect(() => {
    console.log('JukeboxList2 - nameThatTuneMode changed to:', nameThatTuneMode);
  }, [nameThatTuneMode]);

  useEffect(() => {
    const playerControlData = async () => {
      if (message) {
        const data = JSON.parse(message);

        // Handle scroll trigger
        if (data.triggerScroll) {
          csp.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    };
    playerControlData();
  }, [message]);

  useEffect(() => {
    setJukeboxList(jukebox);
  }, [jukebox]);

  useEffect(() => {
    const jl = [];
    let one = {};
    let two = {};
    jukeboxList.forEach((item, i) => {
      if (i % 3 === 0) {
        item.ordinal = i;
        // console.log("one", one);
        jl.push([one, two, item]);
      } else if (i % 3 === 1) {
        item.ordinal = i;
        one = item;
      } else if (i % 3 === 2) {
        item.ordinal = i;
        two = item;
      }
    });
    setJukeboxList2(jl);
  }, [jukeboxList]);

  /////////////////////////////////////////////////////////////////////////

  const options = { loop: true, dragFree: true };
  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    AutoScroll({
      playOnInit: true,
      stopOnInteraction: false,
      startDelay: 500,
      speed: 1,
    }),
  ]);
  const [isPlaying, setIsPlaying] = useState(false);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  // const onButtonAutoplayClick = useCallback(
  //   (callback) => {
  //     const autoScroll = emblaApi?.plugins()?.autoScroll;
  //     if (!autoScroll) return;

  //     const resetOrStop =
  //       autoScroll.options.stopOnInteraction === false
  //         ? autoScroll.reset
  //         : autoScroll.stop;

  //     resetOrStop();
  //     callback();
  //   },
  //   [emblaApi]
  // );

  // const toggleAutoplay = useCallback(() => {
  //   const autoScroll = emblaApi?.plugins()?.autoScroll;
  //   if (!autoScroll) return;

  //   const playOrStop = autoScroll.isPlaying()
  //     ? autoScroll.stop
  //     : autoScroll.play;
  //   playOrStop();
  //   // setTimeout(() => {
  //   //   // playOrStop()
  //   //   console.log('go again')

  //   //   const playOrStopx = autoScroll.isPlaying()
  //   //     ? autoScroll.play
  //   //     : autoScroll.play
  //   //   playOrStopx()
  //   // }, 3000)
  // }, [emblaApi]);

  useEffect(() => {
    const autoScroll = emblaApi?.plugins()?.autoScroll;
    if (!autoScroll) return;

    setIsPlaying(autoScroll.isPlaying());
    emblaApi
      .on("autoScroll:play", () => setIsPlaying(true))
      .on("autoScroll:stop", () => {
        setIsPlaying(false);
      })
      .on("reInit", () => setIsPlaying(autoScroll.isPlaying()));
  }, [emblaApi]);

  // Handle track click - different behavior for Name That Tune mode
  const handleTrackClick = (event, track, index) => {
    console.log('JukeboxList2 - handleTrackClick called', {
      nameThatTuneMode,
      track: track.artist + ' - ' + track.track,
      trackId: track.id
    });

    if (nameThatTuneMode) {
      // Name That Tune mode - send song selection via context message
      console.log('JukeboxList2 - IN GAME MODE - Sending song selection to Name That Tune:', track);

      // Follow the existing message pattern: { propertyName: JSON.stringify(data) }
      const nameThatTuneSelection = {
        nameThatTuneSongSelected: JSON.stringify(track)
      };

      const messageString = JSON.stringify(nameThatTuneSelection);
      console.log('JukeboxList2 - Message string to send:', messageString);

      setMessage(messageString);
      console.log('JukeboxList2 - Message sent via setMessage');
    } else {
      // Normal mode - request track to play
      console.log('JukeboxList2 - Normal mode - requesting track');
      setRequestedTrack(track);
      pickTrack(event, track, index);
    }
  };

  return (
    <>
      {/* Name That Tune Mode Banner */}
      {nameThatTuneMode && (
        <div className="bg-gradient-to-r from-cyan-400 to-purple-500 p-4 text-center animate-pulse">
          <p className="text-white font-bold text-lg">
            🎵 NAME THAT TUNE - Select Your Answer 🎵
          </p>
          <p className="text-white/90 text-sm mt-1">
            Tap on the song you think is playing
          </p>
        </div>
      )}

      <div className={`embla ${showChatlist === true ? "" : "activated"}`}>
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container rounded-2xl">
            {" "}
            {/*widerJbCarousel*/}
            {jukeboxList2 &&
              jukeboxList2.map((item, i) => (
                <div
                  className="embla__slide rounded-2xl bg-gray-100 h-full p-4 m-4 panel-fade"
                  key={i}
                >
                  <div className="embla__slide__number">

                    <div className="flex flex-col items-center justify-start">
                      {item[0].id === undefined && item[1].id === undefined ? (
                        <>
                          <div className="flex flex-col items-center justify-center">
                            <div className="muuzbox-wc-logo"></div>
                            <div className="text-white text-lg font-black font-medium mr-1 w-full">
                              {"Muuzbox Playlist"}<br/>
                              <hr className="mt-4 mb-4 bg-white" />
                            </div>
                            
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className={`flex flex-row items-center py-4 px-3 w-full justify-start ${nameThatTuneMode ? 'cursor-pointer hover:bg-cyan-400/20 transition-colors border-2 border-transparent hover:border-cyan-400/50 rounded-lg' : ''}`}
                            onClick={(event) => handleTrackClick(event, item[0], i)}
                          >
                            <div className="flex flex-col items-center w-2/6">
                              <span className="text-white text-lg font-black font-medium mr-1">
                                {item[0].ordinal + 1}. &nbsp;
                              </span>
                              <img
                                className={"rounded-full mr-1 jukeboxcoveart"}
                                src={item[0].coverart}
                                alt={item[0].track}
                              />
                            </div>
                            <div className="w-4/6">
                              <div className="text-lg font-medium text-white max-h-[32px] overflow-hidden">
                                {item[0].artist}
                                {"xxx"}
                              </div>
                              <div className="text-white max-h-[32px] overflow-hidden text-base">
                                {item[0].track}{" "}
                              </div>
                              <p className="text-white text-base">
                                {item[0].genre}{" "}
                              </p>
                              {item[0].currentSong === "true" && (
                                <div
                                  id="currentsongplaying"
                                  ref={csp}
                                  className="flex flex-row justify-center"
                                >
                                  <div className="playani"></div>
                                </div>
                              )}
                            </div>
                          </div>

                          <div
                            className={`flex flex-row items-center py-4 px-3 w-full justify-start ${nameThatTuneMode ? 'cursor-pointer hover:bg-cyan-400/20 transition-colors border-2 border-transparent hover:border-cyan-400/50 rounded-lg' : ''}`}
                            onClick={(event) => handleTrackClick(event, item[1], i)}
                          >
                            <div className="flex flex-col items-center w-2/6">
                              <span className="text-white text-lg font-black font-medium mr-1">
                                {item[1].ordinal + 1}. &nbsp;
                              </span>
                              <img
                                className={"rounded-full mr-1 jukeboxcoveart"}
                                src={item[1].coverart}
                                alt={item[1].track}
                              />
                            </div>

                            <div className="w-4/6">
                              <div className="text-lg font-medium text-white max-h-[32px] overflow-hidden">
                                {item[1].artist}
                              </div>
                              <div className="text-white max-h-[32px] overflow-hidden text-base">
                                {item[1].track}{" "}
                              </div>
                              <p className="text-white text-base">
                                {item[1].genre}{" "}
                              </p>
                              {item.currentSong === "true" && (
                                <div
                                  id="currentsongplaying"
                                  ref={csp}
                                  className="flex flex-row justify-center"
                                >
                                  <div className="playani"></div>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}

                      <div
                        className={`flex flex-row items-center py-4 px-3 w-full justify-start ${nameThatTuneMode ? 'cursor-pointer hover:bg-cyan-400/20 transition-colors border-2 border-transparent hover:border-cyan-400/50 rounded-lg' : ''}`}
                        onClick={(event) => handleTrackClick(event, item[2], i)}
                      >
                        <div className="flex flex-col items-center w-2/6">
                          <span className="text-white text-lg font-black font-medium mr-1">
                            {item[2].ordinal + 1}. &nbsp;
                          </span>
                          <img
                            className={"rounded-full mr-1 jukeboxcoveart"}
                            src={item[2].coverart}
                            alt={item[2].track}
                          />
                        </div>
                        <div className="w-4/6">
                          <div className="text-lg font-medium text-white max-h-[32px] overflow-hidden">
                            {item[2].artist}
                          </div>
                          <div className="text-white max-h-[32px] overflow-hidden text-base">
                            {item[2].track}{" "}
                          </div>
                          <p className="text-white text-base">
                            {item[2].genre}{" "}
                          </p>
                          {item.currentSong === "true" && (
                            <div
                              id="currentsongplaying"
                              ref={csp}
                              className="flex flex-row justify-center"
                            >
                              <div className="playani"></div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};
